import Backbone from 'backbone'
import template from './alert-subscriptions.hbs'
import alertHelper from 'scoreboard/alerts/alert-helper'
import i18n from 'scoreboard/components/i18n'
import alertMetaData from 'scoreboard/alerts/alert-metadata'
const i18nKeys = alertMetaData.i18nKeys
import { getIconForAlertOrSubscription } from 'scoreboard/alerts/alert'
import appDisplay from 'scoreboard/components/app-display'
import DeleteConfirmation from 'scoreboard/components/delete-confirmation'
import SubscriptionTypeTooltip from 'scoreboard/alerts/subscription-type-tooltip'
import Tooltip from 'scoreboard/components/tooltip'
import metadata from 'scoreboard/components/metadata'
import SubscriptionForm from './subscription-form'
import _ from 'lodash'
import permissions from 'scoreboard/components/permissions'
import user from 'scoreboard/components/user'
import formatValue from 'scoreboard/components/format-value'
import projects from 'scoreboard/projects/projects'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import DataType from 'scoreboard/datasets/model/data-type'
const { YES_NO } = DataType
import $ from 'jquery'
import config from 'scoreboard/components/config'

/**
 * The alert subscriptions list panel to add/edit/delete subscriptions
 */
const AlertSubscriptions = Backbone.View.extend({

	events: {
		'click .add-alert-subscription': 'onAddAlert',
		'click .edit': 'onEditAlert',
		'click .delete-subscription': 'onDeleteAlert'
	},

	initialize: function(opts={}) {
		this.opts = opts
		this.data = this.opts.data
		this.dataByIdByType = alertHelper.dataByIdByDomainType(this.data)
		// Store compiled subscriptions list  as a variable to be updated
		this.subs = this.mapSubscriptions(this.data)
	},

	render: function() {
		this.$el.empty().append(template(this.subs))

		if (!this.covertButtonTooltips) {
			this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
		}

		return this
	},

	/**
	 * Set the subscription list as a variable which gets updated each time a
	 * subscription is added/edited
	 */
	onDeleteAlert: function(e, statusForm) {
		var confirmation = new DeleteConfirmation({
			description: i18n.get('alerts.alertSubscription')
		})
		appDisplay.dialog(confirmation)
		confirmation.on('confirm', function() {
			var subscriptionId = $(e.currentTarget).closest('tr').data('id')
			$.delete('api/alerts/subscriptions/' + subscriptionId, function() {
				var subscription = this.getSubscription(subscriptionId)
				_.remove(this.subs, subscription)
				this.render()
				confirmation.trigger('done')
			}.bind(this))
		}.bind(this))
	},

	/**
	 * Tooltip For New Subscriptions
	 */
	onAddAlert: function(e) {
		var target = $(e.currentTarget)
		// issue #20790 do not show add subscription dialog
		// if the user does not have permission to view any orgs
		if (this.userHasViewableOrgs()) {
			var subscriptionTypeTooltip = new SubscriptionTypeTooltip()

			this._tooltip = new Tooltip({
				extraClass: 'has-bootslide-menu',
				attachTo: target,
				content: subscriptionTypeTooltip,
				placement: 'below',
				arrow: 'right'
			}).render()

			subscriptionTypeTooltip.on('done', ({type, section = 'scorecards'}) => {
				const domainType = metadata[section].domainType
				const options = {
					isNew: true,
					subscriptionItem: { subscription: {type, domainType}}
				}
				var subscriptionForm = new SubscriptionForm(options)
				appDisplay.dialog(subscriptionForm)
				subscriptionForm.on('done', data => this.updateSubscriptionList(data))
			})
		} else {
			this.showViewOrgPermissionsTooltip(target)
		}
	},

	/**
	 * Edit Subscription Dialog
	 */
	onEditAlert: function(e) {
		var target = $(e.currentTarget)
		// issue #20790 do not show edit subscription dialog
		// if the user does not have permission to view any orgs
		if (this.userHasViewableOrgs()) {
			var type = target.data('type')
			var row = this.$('tr').has(target)
			var subscriptionId = row.data('id')

			var subscriptionForm = new SubscriptionForm({
				subscriptionItem: _.extend({type}, this.getSubscription(subscriptionId))
			})

			appDisplay.dialog(subscriptionForm)

			subscriptionForm.on('done', this.updateSubscriptionList.bind(this))
		} else {
			this.showViewOrgPermissionsTooltip(target)
		}
	},

	/**
	 * Maps (enriches) raw subscription objects with additional properties
	 * needed to render the list
	 */
	mapSubscriptions: function(data) {
		const {subscriptions} = data

		return _.map(subscriptions, sub => {
			const {domainId, domainType} = sub
			const domainItem = this._getDomainItem(domainId, domainType)

			sub.rule = this.getRule(sub)
			if (domainItem) {
				return this._mapSubscription(sub, domainItem)
			}

			// #6924 If we can't find a domain node that's probably because the
			// underlying node was deleted
			return {
				subscription: sub,
				domainItem: {
					label: i18n.get(alertMetaData.deletedCodes[domainType], sub.domainId)
				},
				organization: {
					label: i18n.get('alerts.deletedDomainObjectOrganization')
				},
				icon: getIconForAlertOrSubscription(sub, domainType)
			}
		})
	},

	/* Pass in the subscription ID to get data for a specific alert */
	getSubscription: function(id) {
		return _.find(this.subs, d => d.subscription.id == id)
	},

	_getDomainItem(id, type) {
		const domainItems = type && this.dataByIdByType[type]
		return domainItems && domainItems[id]
	},

	userHasViewableOrgs: function () {
		// no projects means the user has no orgs (whether or not projects are enabled)
		return projects.size() > 0
	},

	showViewOrgPermissionsTooltip: function (target) {
		var message = i18n.get('common.security.noViewOrganizations')
		this.permissionsTooltip = new Tooltip({
			attachTo: target,
			content: message,
			placement: 'below',
			arrow: 'center'
		}).render()
	},

	/**
	 * Given a subscription and domain item, map it to the type of object
	 * this view needs to render all the things.
	 *
	 * @param subscription
	 * @param domainItem
	 * @param {id,label} [organization] If not passed, the org will be looked up
	 * in the list of organizations returned for the list of persisted subscriptions.
	 *
	 * @return {{domainItem: *, organization: *, icon: *, section: *, subscription: *}}
	 */
	_mapSubscription: function (subscription, domainItem, organization) {
		// Use subscription.domainType first, it could be 'strategy-map' whereas
		// domainItem.type would be 'dashboard'
		let domainType = subscription.domainType
		// Except for scorecard-item where the more specific icon should be applied
		if (!domainType || domainType === 'scorecard-item') {
			domainType = domainItem.type
		}

		const section = metadata[subscription.domainType].section

		if (!organization) {
			organization = this.dataByIdByType.organizations[domainItem.organizationId]
		}
		return {
			subscription,
			domainItem,
			section,
			organization,
			icon: getIconForAlertOrSubscription(subscription, domainType)
		}
	},

	/**
	 * Invoked after user submits the SubscriptionForm dialog.
	 *
	 * @param data.subscription
	 * @param data.domainItem
	 * @param {id,label} data.organization
	 */
	updateSubscriptionList: function(data) {
		const {subscription, domainItem, organization} = data
		const subData = this._mapSubscription(subscription, domainItem, organization)

		const domainItems = this.dataByIdByType[subscription.domainType]
		domainItems[data.domainItem.id] = _.defaults(domainItem, domainItems[domainItem.id])
		subscription.rule = this.getRule(subscription)

		const existingSubscription = this.getSubscription(subscription.id)
		if (existingSubscription) {
			var replace = _.indexOf(this.subs, existingSubscription)
			this.subs.splice(replace, 1, subData)
		} else {
			this.subs.unshift(subData)
		}

		this.trigger('update-subscription', data)
		this.render()
	},

	// returns the text to display in the "rule" column
	getRule(sub) {
		const {type, domainId, domainType} = sub
		const domainItem = this._getDomainItem(domainId, domainType)

		if (domainItem && _.includes(['metric-value-changed', 'score-changed'], type)) {
			var dataType = type === 'score-changed' ? 'score' : domainItem.dataType
			var threshold = formatValue({
				value: sub.threshold,
				dataType: dataType,
				currencyCode: domainItem.currencyCode,
				precision: 'none',
				shorten: false
			})
			let isYesNoOrCustomText = domainItem.dataType === YES_NO || config.customTextScoringType(domainItem)
			if (type === 'metric-value-changed' && isYesNoOrCustomText) {
				if (sub.threshold == null || sub.threshold === 'null') {
					threshold = i18n.get('alerts.noValue')
				}
				return i18n.get('alerts.metricValueChangedTo.withArg', threshold)
			}
			return i18n.get(i18nKeys[sub.comparison], i18nKeys[type], threshold)
		}

		return i18n.get(i18nKeys[type])
	},

	secure: function() {
		// #13070 no changes should be allowed to notification preferences
		// if user does not have 'Modify Bookmarks and Personal Settings' permission
		if (!permissions.bookmarks()) {
			// remove Add button and Actions column in My Alert Subscriptions panel
			this.$('.add-alert-subscription, .table-actions-cell, .table-actions-cell-header').addClass('is-not-displayed')
		}
		this.$('.subscriptions-table').toggleClass('is-not-displayed', user.isStrictViewer())
	},

	autoRemove: true
})

export default AlertSubscriptions
AlertSubscriptions.__filename__ = 'admin/alerts/alert-subscriptions.js'
